@if (image) {
  <img [src]="imageUrl" [alt]="image.alt" [style.objectPosition]="objectPosition" />
}
